import React from 'react';
/* External */
import PropTypes from 'prop-types';

/* Ott-common */
import Icon from '@dtvgo/icon';

/* Components */
import PlayerButton from '../PlayerButton/PlayerButton';

/* Styles */
import './PlayPauseButton.scss';

function PlayPauseButton({
  handleTogglePlayPause,
  isPlaying,
  tooltipPause,
  tooltipPlay,
  className,
}) {
  return (
    <PlayerButton
      className={`dtv-common-c-play-pause-button-v2 ${className}`}
      onClick={handleTogglePlayPause}
      tooltip={isPlaying ? tooltipPause : tooltipPlay}
      id="btn-play-pause"
    >
      <Icon name={isPlaying ? 'pause' : 'play'} />
    </PlayerButton>
  );
}

PlayPauseButton.propTypes = {
  handleTogglePlayPause: PropTypes.func,
  isPlaying: PropTypes.bool,
  tooltipPause: PropTypes.string,
  tooltipPlay: PropTypes.string,
  className: PropTypes.string,
};

PlayPauseButton.defaultProps = {
  handleTogglePlayPause() {},
  isPlaying: false,
  tooltipPause: '',
  tooltipPlay: '',
  className: '',
};

export default PlayPauseButton;
